import { CancelButton } from "./CourseOverviewModify";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon from "./Icon";
import Input, { InputTextArea } from "./Input";
import { SaveButton } from "./PillarOverviewModify";

interface Props {
  editTopicData: any;
  setEditTopic: (x: any) => void;
  handleEditTopic: (x: any) => void;
  handleDelete: () => void;
}
export const EditTopic = (props: Props) => {
  const { editTopicData, setEditTopic, handleEditTopic, handleDelete } = props;
  return (
    <FlexBox
      style={{
        color: "black",
        padding: 10,
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          paddingBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {editTopicData.id !== "new" ? (
          <div>Edit Knowledge Topic</div>
        ) : (
          <div>Create Knowledge Topic</div>
        )}
        {editTopicData.id !== "new" && (
          <div
            style={{
              display: "flex",
              alignItems: "end",
              fontWeight: "normal",
              color: "red",
              cursor: "pointer",
            }}
            className="reduce_opct_onhover"
            onClick={handleDelete}
          >
            <Icon size={3} style={{ paddingRight: "1px" }} name={"delete"} />
            Delete
          </div>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 2fr 1fr",
          gap: "10px",
          width: "100%",
          padding: 5,
        }}
      >
        <label style={{ gridColumn: "1 / 2" }}>Title</label>
        <Input
          // isFullWidth
          style={{ gridColumn: "2 / 4", width: "100%" }}
          maxLength={64}
          value={editTopicData.title}
          onChange={(e: any) => {
            setEditTopic({
              ...editTopicData,
              title: e.target.value,
            });
          }}
        />
        <label style={{ gridColumn: "1 / 2" }}>Description</label>
        <InputTextArea
          value={editTopicData.description}
          isFullWidth
          style={{
            width: "100%",
            minHeight: "200px",
            gridColumn: "2 / 4",
          }}
          maxLength={256}
          onChange={(e: any) => {
            setEditTopic({
              ...editTopicData,
              description: e.target.value,
            });
          }}
        />
      </div>
      <FlexBox
        justify="end"
        style={{
          padding: "10px",
          width: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: 30,
          }}
        >
          <CancelButton
            onClick={() => setEditTopic({ id: "", title: "", description: "" })}
            className="reduce_opct_onhover"
            style={{
              padding: "8px 40px",
              color: "white",
              width: 110,
            }}
          >
            {/* <Icon style={{ paddingRight: "8px" }} name={"save"} /> */}
            Cancel
          </CancelButton>
          <SaveButton
            onClick={handleEditTopic}
            className="reduce_opct_onhover"
            style={{
              padding: "8px 40px",
              color: "white",
              width: 110,
            }}
          >
            <Icon style={{ paddingRight: "8px" }} name={"save"} />
            Save
          </SaveButton>
        </div>
      </FlexBox>
    </FlexBox>
  );
};
